import { call, put, select, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { Creators as GlobalCreators } from 'store/globals/globals-duck.js';
import toastApiError from 'utils/api-error.js';
import * as Api from './specialists-api.js';
import { Creators, Types } from './specialists-duck.js';

const getState = (state) => state.Specialist;

export function* fetchAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getSpecialists);
    yield put(Creators.specialistsFetched(response.data));
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* createAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.createSpecialist, data);
    yield put(Creators.specialistsCloseModal());
    toast.success('Especialista criado com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield call(fetchAsync);
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const { id, ...rest } = data;
    yield call(Api.updateSpecialist, id, rest);
    yield put(Creators.specialistsCloseModal());
    toast.success('Especialista atualizado com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield call(fetchAsync);
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* deleteAsync({ id }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.deleteSpecialist, id);
    toast.success('Especialista removido com sucesso!');
    yield call(fetchAsync);
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateOrdersAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const state = yield select(getState);
    yield call(Api.updateSpecialistsOrders, { items: state.specialistsToUpdateOrder });
    toast.success('Ordem dos especialistas atualizada com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield call(fetchAsync);
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export default [
  takeLatest(Types.SPECIALISTS_FETCH_ASYNC, fetchAsync),
  takeLatest(Types.SPECIALISTS_CREATE_ASYNC, createAsync),
  takeLatest(Types.SPECIALISTS_UPDATE_ASYNC, updateAsync),
  takeLatest(Types.SPECIALISTS_DELETE_ASYNC, deleteAsync),
  takeLatest(Types.SPECIALISTS_UPDATE_ORDERS_ASYNC, updateOrdersAsync),
];
